import className from "classnames/bind";
import {FontAwesomeIcon} from "~/components";
import {RATING_COLOR} from "./ratings";
import style from "../style/PageSpeed.module.scss";

const cn = className.bind(style);

const STATUS = {
	pass: {color: RATING_COLOR.good, icon: 'fa-light fa-circle-check', label: 'Đạt'},
	fail: {color: RATING_COLOR.poor, icon: 'fa-light fa-circle-xmark', label: 'Chưa đạt'},
	na:   {color: RATING_COLOR.na,   icon: 'fa-light fa-circle-minus', label: 'Không có dữ liệu'},
};

/**
 * Mobile Friendly (#15): 3 thẻ kiểm riêng (viewport / cỡ chữ / vùng chạm) tách từ
 * audit Lighthouse — strat.mobile_friendly = {available, checks:[{key,label,status,
 * display,message,evidence}]}. Báo cáo cũ (chưa có field này) → không render.
 */
function MobileFriendly({data}) {
	if (!data || !data.available) return null;

	return (
		<div className={cn('cwv-block')}>
			<div className={cn('cwv-head')}>
				<FontAwesomeIcon icon="fa-light fa-mobile-screen-button" /> Thân thiện di động
			</div>
			<div className={cn('metric-grid')}>
				{(data.checks || []).map((c) => {
					const s = STATUS[c.status] || STATUS.na;
					return (
						<div key={c.key} className={cn('metric')} style={{borderLeftColor: s.color}}>
							<div className={cn('metric-label')}>{c.label}</div>
							<div className={cn('metric-value')} style={{color: s.color, fontSize: 16}}>
								<FontAwesomeIcon icon={s.icon} /> {c.display || s.label}
							</div>
							{c.message && <div className={cn('metric-rating')}>{c.message}</div>}
							{c.evidence && c.evidence.length > 0 && (
								<ul className={cn('mf-evidence')}>
									{c.evidence.slice(0, 5).map((e, i) => (
										<li key={i}>{e.label}{e.note ? ` — ${e.note}` : ''}</li>
									))}
								</ul>
							)}
						</div>
					);
				})}
			</div>
		</div>
	);
}

export default MobileFriendly;
